import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gutter-installation")({
  beforeLoad: () => {
    throw redirect({ to: "/services/gutter-installation", statusCode: 301 });
  },
});
